import { mapGetters } from 'vuex'

import axios from 'axios'
import _ from 'lodash'
import { RotateCcwIcon, XCircleIcon } from 'vue-feather-icons'

import image from '@/assets/images/empty_lockers.png'
import backgroundImage from '@/assets/images/locker-bg.svg'
import CurrentUserResolver from '@/mixins/current-user-resolver.js'
// import lockersStore from '@/stores/lockers-store.js'
import SelfAssignableCpsModal from '@/vcs/_shared/modals/self-assignable-cps-modal/cmp.vue'

import Locker from './locker/cmp.vue'
import LockerFilterButton from './LockerFilterButton.vue'
import LockerSearchInput from './LockerSearchInput.vue'

const PAGE_SIZE = 10

export default {
  name: 'Lockers',
  mixins: [CurrentUserResolver],
  components: {
    RotateCcwIcon,
    XCircleIcon,
    LockerFilterButton,
    Locker,
    LockerSearchInput,
    LockerSearchInfo: () => import('./LockerSearchInfo.vue'),
    Blocker: () => import('@/vcs/_shared/blocker/cmp.vue'),
  },
  data: function () {
    return {
      image: image,
      backgroundImage: backgroundImage,

      lockers: [],
      search: {
        page: 0,
        text: '',
      },

      isSearchVisible: false,
      isSearchOverlayVisible: false,
      blocker: false,
    }
  },
  created() {
    window.mainApp.$on('updateLockers', this.fetchLockers)
  },
  beforeDestroy() {
    window.mainApp.$off('updateLockers')
  },
  mounted() {
    // TODO: this.lockers = lockersStore.state.lockers
    this.fetchLockers(this.search)
  },
  computed: {
    ...mapGetters({
      showMyLockersOnly: 'showMyLockersOnly',
    }),
    hasAnyMembersInSpContainingSelfAssignedCps() {
      return (this.currentUser || {}).hasAnyMembersInSpContainingSelfAssignedCps
    },
  },
  methods: {
    fetchLockers(search = { page: 0, text: '' }, additionalFetch = false) {
      this.blocker = true
      const { page, text } = search
      const params = {
        page: page,
        page_size: PAGE_SIZE,
        text: text,
      }
      if (this.showMyLockersOnly) {
        params.user_id = this.currentUser.id
      }
      axios({
        method: 'get',
        url: 'boxes',
        params: params,
      })
        .then(response => {
          if (additionalFetch) {
            this.lockers = [...this.lockers, ...response.data]
          } else {
            this.lockers = response.data
          }
        })
        .catch(error => {
          console.error('fetchLockers error', error.response)
        })
        .finally(() => {
          this.blocker = false
        })
    },
    loadMoreLockers() {
      const search = {
        ...this.search,
        page: this.search.page + 1,
      }
      this.search = { ...search }
      this.fetchLockers(search, true)
    },
    resetTextSearchHandler() {
      this.search = { ...this.search, page: 0, text: '' }
      this.fetchLockers(this.search)
    },
    openSelfAssignableCpsModal() {
      this.$store.commit('modal/open', {
        cmp: SelfAssignableCpsModal,
        animation: 'slide-down-menu',
        callback: this.fetchLockers,
      })
    },
    openSearch() {
      this.isSearchVisible = true
      this.isSearchOverlayVisible = true
    },
    closeSearch() {
      this.isSearchVisible = false
      this.isSearchOverlayVisible = false
    },
    closeSearchOverlay() {
      this.isSearchOverlayVisible = false
      this.isSearchVisible = false
    },
    updateSearchTextHandler: _.debounce(function (event) {
      this.updateSearchTextAndFetch({ text: event.target.value })
    }, 300),
    updateSearchTextAndFetch(options) {
      this.search.text = options.text
      this.search.page = 0
      this.search = { ...this.search }
      this.fetchLockers(this.search)
    },
    searchAfterClosingModalHandler() {
      this.search = { ...this.search }
      this.fetchLockers(this.search)
    },
  },
}
